import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"
import { ThemeProvider } from "@emotion/react"
import styled from "@emotion/styled"
import { connect } from "react-redux"
import { segmentEvent } from "@nutrafol/nutrafol-ui-kit/utils/segmentfunctions"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"

import Helmet from "react-helmet"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import Header from "../header"
import ExternalScripts from "../externalscripts"
import { getSectionFromUrl } from "../../utils/general"

import {
  setCurrentSection,
  setProgress,
  unendQuizEarly,
  setEmailCapture,
  setLocation,
} from "../../actions"

const Main = styled.main`
  //https://developer.mozilla.org/en-US/docs/Web/CSS/length#relative_length_units_based_on_viewport
  height: 100dvh;
  @media (min-width: 768px) {
    height: 100%;
  }
  //see https://developer.mozilla.org/en-US/docs/Web/CSS/length#relative_length_units_based_on_viewport
  /* min height set on body to preserve scroll events */
  /* min-height: 675px; */
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  position: relative;
  /* ${queries.medium`
    min-height: 750px;
  `} */
  &.mousedown {
    *:focus {
      outline: none;
    }
  }
  &.no-route {
    align-items: stretch;
    > div {
      align-items: flex-start;
    }
  }
`

const Layout = (props) => {
  const { setCurrentSection, setProgress, setLocation } = props

  const data = useStaticQuery(graphql`
    query SiteTitleAndQuizQuery {
      site {
        siteMetadata {
          title
        }
      }
      quiz {
        version
        sections {
          name
          path
          questions {
            id
            text
            subText
            type
            autoProgress
            answers {
              text
              noHairHistory
            }
          }
        }
      }
    }
  `)

  const browserSectionCorrection = () => {
    props.setEmailCapture(false)

    let urlSection = getSectionFromUrl()

    if (urlSection !== "") {
      setCurrentSection(urlSection)
      setProgress(0)
      props.unendQuizEarly()
    } else {
      cleanReset()
    }
  }

  useEffect(() => {
    if (typeof window !== `undefined`) {
      let urlSection = getSectionFromUrl()
      if (urlSection === "results") {
        setCurrentSection("results")
      } else if (urlSection === "") {
        cleanReset()
        setProgress(0)
        setCurrentSection("basics")
      }
    }
  }, [])

  // Update location in Redux whenever it changes
  useEffect(() => {
    if (props.location) {
      setLocation({
        pathname: props.location.pathname || "",
        search: props.location.search || "",
        hash: props.location.hash || "",
        href:
          typeof window !== `undefined`
            ? window.location.href
            : props.location.pathname || "",
      })
    }
  }, [props.location, setLocation])

  const cleanReset = () => {
    setProgress(0)
  }

  useEffect(() => {
    if (typeof window !== `undefined`) {
      window.addEventListener("popstate", browserSectionCorrection)

      if (getSectionFromUrl() === "") {
        cleanReset()
      }

      const getCampaignItems = () => {
        const self = window.location.toString()
        const qtring = self.split("?")
        const campaign = {}
        if (qtring.length > 1) {
          const pairs = qtring[1].split("&")
          pairs.forEach((item) => {
            var keyval = item.split("=")
            var newKey =
              keyval[0] === "utm_campaign"
                ? "name"
                : keyval[0].replace("utm_", "")
            campaign[newKey] = decodeURIComponent(keyval[1])
          })
        }
        return campaign
      }

      if (props.location && props.location.search !== undefined) {
        if (!props.location.search.includes("id=")) {
          setTimeout(() => {
            segmentEvent("Quiz First Page Viewed", {
              quiz_version: process.env.GATSBY_QUIZ_VERSION,
              context: {
                campaign: getCampaignItems(),
              },
            })
          }, 2000)
        }
      }
    }

    return function () {
      window.removeEventListener("popstate", browserSectionCorrection)
    }
  }, [])

  const [mouseDown, setMouseDown] = useState(false)

  /** mouseDown is used to removed outline style for focused elements on mouse click but show for tab navigation */
  useEffect(() => {
    document.addEventListener("mousedown", () => {
      setMouseDown(true)
    })

    document.addEventListener("keydown", (e) => {
      if (e.key === "Tab" || e.keyCode === 9) {
        setMouseDown(false)
      }
    })
  }, [])

  let path =
    typeof props.location !== `undefined` &&
    typeof props.location.pathname !== `undefined`
      ? props.location.pathname
      : ""
  let strippedPath = !!path ? path.split('/').filter(Boolean).pop() : ""

  const { children } = props

  return (
    <>
      <ThemeProvider theme={theme}>
        <Header
          siteTitle={data.site.siteMetadata.title}
          quizData={data.quiz}
          location={props.location}
          mouseDown={mouseDown}
        />
        <Main
          className={`app-main ${
            strippedPath === "" ? "no-route" : strippedPath
          }  ${mouseDown ? "mousedown" : ""}`}
        >
          {children}
        </Main>
        <ExternalScripts />
      </ThemeProvider>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

const mapStateToProps = (state) => {
  return {
    currentSection: state.sectionReducer.currentSection,
    currentQuestionId: state.questionIdReducer.currentQuestionId,
    endQuizEarly: state.progressReducer.endQuizEarly,
    email_capture: state.progressReducer.email_capture,
  }
}

export default connect(mapStateToProps, {
  setCurrentSection,
  setProgress,
  unendQuizEarly,
  setEmailCapture,
  setLocation,
})(Layout)
